import React from 'react';
import { classNames } from '@src/utils';
import './auth.scss';
var prefixCls = 'auth-page';
var className = classNames('page', prefixCls);
var AuthPage = function () {
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: prefixCls + "_loading" }, "\u52A0\u8F7D\u4E2D...")));
};
export default React.memo(AuthPage);
